<template>
  <div v-if="post" class="frisbuy-popup-overlay" @click.self="popupClose">
    <div
      :class="{
        'frisbuy-popup': true,
        'frisbuy-scroller': true,
        'frisbuy-complain-show': showComplainForm,
        'frisbuy-has-share': popupSettings.shareButtons.enable,
      }"
    >
      <div
        class="frisbuy-popup-controls"
        :class="{
          'frisbuy-popup-controls-no-navigation': postList.length == 1,
        }"
      >
        <div class="frisbuy-popup-navigation" v-if="postList.length > 1">
          <div class="frisbuy-popup-control frisbuy-prev" @click="popupPrev">
            <svg
              width="16.530331"
              height="13.06066"
              viewBox="0 0 16.530331 13.06066"
              version="1.1"
              id="svg4"
            >
              <path
                d="M 6.5303301,0.53033009 0.53033009,6.5303301 m 0,0 L 6.5303301,12.53033 M 0.53033009,6.5303301 H 8.5303301 16.53033"
                id="path2"
              />
            </svg>
          </div>
          <div class="frisbuy-popup-control frisbuy-next" @click="popupNext">
            <svg
              width="16.530331"
              height="13.06066"
              viewBox="0 0 16.530331 13.06066"
              version="1.1"
              id="svg4"
            >
              <path
                d="M 6.5303301,0.53033009 0.53033009,6.5303301 m 0,0 L 6.5303301,12.53033 M 0.53033009,6.5303301 H 8.5303301 16.53033"
                id="path2"
              />
            </svg>
          </div>
        </div>
        <div class="frisbuy-popup-control frisbuy-close" @click="popupClose">
          <svg viewBox="0 0 512 512" style="enable-background: new 0 0 512 512">
            <path
              d="M286.17,256L505.752,36.418c8.331-8.331,8.331-21.839,0-30.17c-8.331-8.331-21.839-8.331-30.17,0L256,225.83L36.418,6.248
			c-8.331-8.331-21.839-8.331-30.17,0c-8.331,8.331-8.331,21.839,0,30.17L225.83,256L6.248,475.582
			c-8.331,8.331-8.331,21.839,0,30.17c8.331,8.331,21.839,8.331,30.17,0L256,286.17l219.582,219.582
			c8.331,8.331,21.839,8.331,30.17,0c8.331-8.331,8.331-21.839,0-30.17L286.17,256z"
            />
          </svg>
        </div>
      </div>
      <div
        v-touch:swipe="swipeHandler"
        class="frisbuy-content-wrapper frisbuy-scroller"
        ref="scrollWrapper"
        :style="swipeStyle"
      >
        <div class="frisbuy-popup-content">
          <div class="frisbuy-popup-media">
            <div
              :class="{
                [`frisbuy-provider-${post.frisbuyPost.providerType}`]:
                  !isCensored,
              }"
            ></div>
            <div
              v-if="popupSettings.showReportButton && !isPlaying"
              class="frisbuy-complain-button"
              @click="showComplainForm = true"
            >
              <svg
                width="12"
                height="11"
                viewBox="0 0 12 11"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M5.79753 0.0286079C5.53223 0.0911624 5.27861 0.271445 5.08505 0.535087C5.00335 0.646357 0.986797 7.36038 0.301285 8.53157C0.0909552 8.89089 0.0188286 9.08942 0.0039888 9.34978C-0.00589645 9.52317 0.000796937 9.58208 0.0445541 9.7073C0.182852 10.103 0.531671 10.3225 1.1058 10.3752C1.46515 10.4083 10.5349 10.4083 10.8942 10.3752C11.4683 10.3225 11.8171 10.103 11.9554 9.7073C11.9992 9.58208 12.0059 9.52317 11.996 9.34978C11.9812 9.08942 11.909 8.89089 11.6987 8.53157C11.0132 7.36038 6.99665 0.646357 6.91495 0.535087C6.71488 0.262565 6.44843 0.0787991 6.17153 0.022334C6.0181 -0.00894327 5.9521 -0.00783608 5.79753 0.0286079ZM6.31235 2.75388C6.61243 2.85641 6.8275 3.12174 6.88353 3.4585C6.90887 3.61101 6.88834 3.79067 6.76245 4.51749C6.64688 5.1847 6.52899 5.93999 6.48886 6.2705C6.46804 6.44176 6.44553 6.61561 6.43881 6.65685L6.42659 6.73181H6.002H5.57739L5.56071 6.54152C5.52477 6.13169 5.39862 5.34 5.16468 4.05618C5.10028 3.70272 5.09399 3.63197 5.11412 3.48728C5.1699 3.08651 5.45214 2.78207 5.82688 2.71843C5.9616 2.69557 6.19058 2.71227 6.31235 2.75388ZM6.36921 7.33033C6.52399 7.40372 6.7291 7.59208 6.79835 7.72436C6.88631 7.89249 6.91766 8.09327 6.88376 8.27148C6.868 8.35426 6.83324 8.46353 6.80652 8.51427C6.73098 8.6576 6.5419 8.82513 6.3653 8.90517C6.22626 8.96816 6.18182 8.97688 6 8.97688C5.81818 8.97688 5.77374 8.96816 5.6347 8.90517C5.459 8.82554 5.26909 8.65774 5.19455 8.51628C5.1135 8.36245 5.08324 8.15657 5.11619 7.98334C5.15375 7.78599 5.23155 7.64377 5.37278 7.51434C5.59973 7.30631 5.71804 7.26166 6.02382 7.26867C6.2085 7.27291 6.27202 7.28424 6.36921 7.33033Z"
                  fill="white"
                />
              </svg>
              {{ popupText.complain }}
            </div>
            <div
              class="frisbuy-complain-form"
              :class="{ 'frisbuy-complain-message': complainSended }"
              v-if="showComplainForm"
              @touchemove.stop
            >
              <template v-if="complainSended">
                <div class="frisbuy-complain-form__title">
                  {{ popupText.complainAccepted }}<br />
                  {{ popupText.afterAccept }}
                </div>
                <div class="frisbuy-complain-form__buttons">
                  <button @click="showComplainForm = false">
                    {{ popupText.ok }}
                  </button>
                </div>
              </template>
              <template v-else>
                <div class="frisbuy-complain-form__title">
                  {{ popupText.confirm }}
                </div>
                <div class="frisbuy-complain-form__note">
                  {{ popupText.complainNote }}
                </div>
                <div class="frisbuy-complain-form__email">
                  <label>E-Mail*</label>
                  <input
                    type="email"
                    @input="complainError = null"
                    v-model="email"
                  />
                </div>
                <div class="frisbuy-complain-form__text">
                  <label>{{ popupText.complainText }}</label>
                  <textarea
                    cols="30"
                    rows="5"
                    v-model="complainText"
                    @input="complainError = null"
                  ></textarea>
                </div>
                <div class="frisbuy-complain-form__buttons">
                  <button
                    @click="showComplainForm = false"
                    :disabled="inSending"
                  >
                    {{ popupText.cancel }}
                  </button>
                  <button
                    :class="{ 'frisbuy-button-loading': inSending }"
                    @click="sendComplain"
                    :disabled="inSending"
                  >
                    {{ popupText.submit }}
                  </button>
                </div>
                <div class="frisbuy-complain-form__error" v-if="complainError">
                  {{ complainError }}
                </div>
              </template>
            </div>

            <post-image
              v-if="
                !isPlaying ||
                !mediaIsVideo ||
                (typeof popupVideoPositionStyles !== 'undefined' &&
                  Object.keys(popupVideoPositionStyles).length > 0)
              "
              :style="{
                visibility: !isPlaying || !mediaIsVideo ? 'visible' : 'hidden',
              }"
              :media="currentMedia"
              :post="post"
              :settings="settings"
              ref="postImage"
            ></post-image>

            <div
              class="frisbuy-media-play"
              v-if="currentMedia.videoUrl && !isPlaying"
              @click="isPlaying = true"
            >
              <img :src="`${envDomain}/images/widget/play.svg`" />
            </div>

            <div v-if="currentMedia.videoUrl" class="frisbuy-video-wrapper">
              <video
                :style="popupVideoPositionStyles"
                :controls="isPlaying"
                loop="true"
                controlsList="nodownload"
                :autoplay="popupSettings.autoplayVideo"
                :muted="popupSettings.isVideoMuted"
                @loadeddata="videoLoaded"
                ref="video"
                @pause="pauseVideo"
                playsinline
              >
                <source @error="errorVideoHandler" type="video/mp4" />
              </video>
            </div>

            <div class="frisbuy-gallery-navigation" v-if="isMultiPosts">
              <div
                class="frisbuy-navigation-button"
                v-if="mediaIndex"
                @click="navigate(mediaIndex - 1)"
              >
                <svg
                  width="16.530331"
                  height="13.06066"
                  viewBox="0 0 16.530331 13.06066"
                  version="1.1"
                  id="svg4"
                >
                  <path
                    d="M 6.5303301,0.53033009 0.53033009,6.5303301 m 0,0 L 6.5303301,12.53033 M 0.53033009,6.5303301 H 8.5303301 16.53033"
                    id="path2"
                  />
                </svg>
              </div>
              <span></span>
              <div
                class="frisbuy-navigation-button"
                v-if="mediaIndex !== post.media.length - 1"
                @click="navigate(mediaIndex + 1)"
              >
                <svg
                  width="16.530331"
                  height="13.06066"
                  viewBox="0 0 16.530331 13.06066"
                  version="1.1"
                  id="svg4"
                >
                  <path
                    d="M 6.5303301,0.53033009 0.53033009,6.5303301 m 0,0 L 6.5303301,12.53033 M 0.53033009,6.5303301 H 8.5303301 16.53033"
                    id="path2"
                  />
                </svg>
              </div>
            </div>
            <div class="frisbuy-gallery-pagination" v-if="isMultiPosts">
              <div
                :class="{
                  'frisbuy-gallery-page': true,
                  active: index == mediaIndex,
                  'frisbuy-video-play': isPlaying,
                }"
                v-for="(mediaItem, index) in post.media"
                @click="navigate(index)"
              ></div>
            </div>
          </div>
        </div>
        <div
          class="frisbuy-popup-details"
          :class="{ 'frisbuy-details-no-post-text': !post.frisbuyPost.text }"
        >
          <div
            class="frisbuy-details-scroller frisbuy-scroller"
            ref="scrollDetails"
          >
            <div class="frisbuy-post-details">
              <div
                v-if="false"
                class="frisbuy-brand"
                :style="{
                  'background-image': `url(${post.instagramPost.authorUser.avatarUrl})`,
                }"
              ></div>
              <a
                :href="
                  popupSettings.enableAuthorLink
                    ? post.instagramPost.postLink
                    : undefined
                "
                target="_blank"
                >{{
                  post.instagramPost.authorUser.fio ||
                  `@${post.instagramPost.authorUser.username}`
                }}</a
              >
              <template v-if="post.frisbuyPost.providerType !== 'frisbuy'">
                <div>
                  <svg
                    width="23"
                    height="21"
                    viewBox="0 0 23 21"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M1.97041 2.08174C4.43099 -0.378843 8.42039 -0.378804 10.8809 2.08183L11.104 2.30488L11.327 2.08183C13.7875 -0.378803 17.7769 -0.378841 20.2375 2.08174C22.698 4.54228 22.698 8.5316 20.2375 10.9921L11.1039 20.1258L1.9704 10.9921C-0.490136 8.5316 -0.490132 4.54228 1.97041 2.08174ZM9.64346 3.31924C7.86634 1.54205 4.985 1.54202 3.20785 3.31917C1.43072 5.0963 1.43072 7.97758 3.20784 9.75471L11.1039 17.6509L19.0001 9.75471C20.7772 7.97758 20.7772 5.0963 19.0001 3.31918C17.2229 1.54202 14.3416 1.54205 12.5645 3.31924L11.7227 4.16105L10.4852 4.16104L9.64346 3.31924Z"
                      fill="#002354"
                    />
                  </svg>

                  {{ post.instagramPost.likeCountShort }}
                </div>
                <div>
                  <svg
                    width="23"
                    height="22"
                    viewBox="0 0 23 22"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M1 19.6602L6.10316 16.3762H21.5016V1H1V19.6602Z"
                      stroke="#002354"
                      stroke-width="1.75"
                      stroke-linecap="square"
                    />
                    <path
                      d="M6.75234 9.88408C7.42889 9.88408 7.97734 9.33563 7.97734 8.65908C7.97734 7.98253 7.42889 7.43408 6.75234 7.43408C6.07579 7.43408 5.52734 7.98253 5.52734 8.65908C5.52734 9.33563 6.07579 9.88408 6.75234 9.88408Z"
                      fill="#002354"
                    />
                    <path
                      d="M11.2523 9.88408C11.9289 9.88408 12.4773 9.33563 12.4773 8.65908C12.4773 7.98253 11.9289 7.43408 11.2523 7.43408C10.5758 7.43408 10.0273 7.98253 10.0273 8.65908C10.0273 9.33563 10.5758 9.88408 11.2523 9.88408Z"
                      fill="#002354"
                    />
                    <path
                      d="M15.7523 9.88408C16.4289 9.88408 16.9773 9.33563 16.9773 8.65908C16.9773 7.98253 16.4289 7.43408 15.7523 7.43408C15.0758 7.43408 14.5273 7.98253 14.5273 8.65908C14.5273 9.33563 15.0758 9.88408 15.7523 9.88408Z"
                      fill="#002354"
                    />
                  </svg>

                  {{ post.instagramPost.commentCountShort }}
                </div>
              </template>
            </div>

            <div
              class="frisbuy-post-text"
              v-html="tageted(post.frisbuyPost.text)"
            ></div>

            <div
              v-if="currentMedia.linkList.length > 0"
              class="frisbuy-products-list__title"
            >
              Товары из образа
            </div>

            <div
              :class="{
                'frisbuy-products-list': true,
                'frisbuy-products-inline': !showSkuPics,
                'frisbuy-has-link': hasLink,
              }"
            >
              <a
                v-for="(link, index) in currentMedia.linkList"
                class="frisbuy-product-item"
                @click="linkClick($event, link, index)"
                :href="!hideBuyButton(link) && link.link"
                :target="
                  Boolean(popupSettings.targetBlankLink) ? '_blank' : '_self'
                "
                @mouseenter="mouseOver(link, true)"
                @mouseleave="mouseOver(link, false)"
              >
                <div
                  v-if="showUnpinnedNumbers"
                  :class="{
                    'frisbuy-marker': true,
                    'frisbuy-marker-hover': link.hover,
                  }"
                  :style="{ color: popupSettings.image.numberColor }"
                >
                  <span>{{ index + 1 }}</span>
                </div>
                <div
                  class="frisbuy-product-image"
                  :style="{ 'background-image': `url(${link.sku.thumbUrl})` }"
                >
                  <div class="frisbuy-similar-title" v-if="link.isSimilar">
                    {{ popupText.similarGood }}
                  </div>
                </div>

                <div class="frisbuy-product-item__info">
                  <span class="frisbuy-product-item__title">
                    {{ link.title }}
                  </span>
                  <div v-if="link.sku.price" class="frisbuy-product-price">
                    <span
                      :class="{ 'frisbuy-has-discount': link.sku.priceOld }"
                    >
                      {{ link.sku.price }}
                      {{
                        link.sku.currencySymbol ||
                        popupSettings.currencySymbol ||
                        ""
                      }}
                      <span
                        v-if="
                          !popupSettings.currencySymbol &&
                          !link.sku.currencySymbol
                        "
                      >
                        ₽
                      </span>
                    </span>
                    <span class="frisbuy-price-old" v-if="link.sku.priceOld">
                      {{ link.sku.priceOld }}
                      {{
                        link.sku.currencySymbol ||
                        popupSettings.currencySymbol ||
                        ""
                      }}
                      <span
                        v-if="
                          !popupSettings.currencySymbol &&
                          !link.sku.currencySymbol
                        "
                      >
                        ₽
                      </span>
                    </span>
                  </div>
                  <button class="frisbuy-product-item__buy-button">
                    {{ buttonText(link) }}
                  </button>
                </div>
              </a>
            </div>
            <div
              class="frisbuy-similar"
              v-if="
                currentMedia.similarGoods && currentMedia.similarGoods.length
              "
            >
              <div class="frisbuy-similar-title">
                {{ popupText.similarGoods }}
              </div>
              <div class="frisbuy-products-wrapper">
                <div class="frisbuy-gallery-navigation">
                  <div
                    class="frisbuy-navigation-button"
                    v-if="canPrevProduct"
                    @click="navigateProducts(-1)"
                  >
                    <svg version="1.1" viewBox="0 0 24 32" xml:space="preserve">
                      <polyline
                        stroke="currentColor"
                        fill="none"
                        points="16,24 8,16 16,8"
                      />
                    </svg>
                  </div>
                  <span></span>
                  <div
                    class="frisbuy-navigation-button"
                    v-if="canNextProduct"
                    @click="navigateProducts(1)"
                  >
                    <svg version="1.1" viewBox="0 0 24 32" xml:space="preserve">
                      <polyline
                        stroke="currentColor"
                        fill="none"
                        points="8,8 16,16 8,24"
                      />
                    </svg>
                  </div>
                </div>
                <div
                  class="frisbuy-products-list"
                  ref="productList"
                  @scroll="productsScrollHandler"
                >
                  <a
                    v-for="(link, index) in currentMedia.similarGoods"
                    class="frisbuy-product-item"
                    @click="similarLinkClick($event, link, index)"
                    :href="link.vendorShopUrl"
                    :target="
                      Boolean(popupSettings.targetBlankLink)
                        ? '_blank'
                        : undefined
                    "
                  >
                    <div
                      class="frisbuy-product-image"
                      :style="{ 'background-image': `url(${link.imageUrl})` }"
                    ></div>
                    <div
                      v-if="link.price"
                      :class="{
                        'frisbuy-product-price': true,
                        'frisbuy-no-discount': !link.priceOld,
                      }"
                    >
                      <span
                        >{{ link.price }} {{ popupSettings.currencySymbol || ""
                        }}<svg
                          v-if="!popupSettings.currencySymbol"
                          viewBox="0 0 510.127 510.127"
                        >
                          <path
                            fill="currentColor"
                            d="M34.786 428.963h81.158v69.572c0 3.385 1.083 6.156 3.262 8.322 2.173 2.18 4.95 3.27 8.335 3.27h60.503c3.14 0 5.857-1.09 8.152-3.27 2.295-2.166 3.44-4.938 3.44-8.322v-69.572h182.963c3.377 0 6.156-1.076 8.334-3.256 2.18-2.178 3.262-4.95 3.262-8.336v-46.376c0-3.365-1.082-6.156-3.262-8.322-2.172-2.18-4.957-3.27-8.334-3.27h-182.97v-42.754h123.184c48.305 0 87.73-14.72 118.293-44.2 30.55-29.448 45.834-67.49 45.834-114.124 0-46.604-15.284-84.646-45.835-114.125C410.548 14.75 371.115 0 322.812 0H127.535c-3.385 0-6.157 1.09-8.335 3.256-2.173 2.18-3.262 4.97-3.262 8.335v227.897H34.786c-3.384 0-6.157 1.145-8.335 3.44-2.17 2.294-3.26 5.01-3.26 8.15v53.978c0 3.385 1.082 6.158 3.26 8.336 2.18 2.18 4.946 3.257 8.336 3.257h81.158V359.4H34.786c-3.384 0-6.157 1.09-8.335 3.27-2.17 2.167-3.26 4.952-3.26 8.323v46.377c0 3.385 1.082 6.158 3.26 8.336 2.18 2.18 4.95 3.257 8.336 3.257zM199.628 77.18h115.938c25.6 0 46.248 7.484 61.953 22.46 15.696 14.975 23.548 34.546 23.548 58.69 0 24.156-7.852 43.733-23.55 58.69-15.704 14.99-36.353 22.474-61.952 22.474H199.628V77.18z"
                          />
                        </svg>
                      </span>
                      <span class="frisbuy-price-old" v-if="link.priceOld"
                        >{{ link.priceOld }}
                        {{ popupSettings.currencySymbol || ""
                        }}<svg
                          v-if="!popupSettings.currencySymbol"
                          viewBox="0 0 510.127 510.127"
                        >
                          <path
                            fill="currentColor"
                            d="M34.786 428.963h81.158v69.572c0 3.385 1.083 6.156 3.262 8.322 2.173 2.18 4.95 3.27 8.335 3.27h60.503c3.14 0 5.857-1.09 8.152-3.27 2.295-2.166 3.44-4.938 3.44-8.322v-69.572h182.963c3.377 0 6.156-1.076 8.334-3.256 2.18-2.178 3.262-4.95 3.262-8.336v-46.376c0-3.365-1.082-6.156-3.262-8.322-2.172-2.18-4.957-3.27-8.334-3.27h-182.97v-42.754h123.184c48.305 0 87.73-14.72 118.293-44.2 30.55-29.448 45.834-67.49 45.834-114.124 0-46.604-15.284-84.646-45.835-114.125C410.548 14.75 371.115 0 322.812 0H127.535c-3.385 0-6.157 1.09-8.335 3.256-2.173 2.18-3.262 4.97-3.262 8.335v227.897H34.786c-3.384 0-6.157 1.145-8.335 3.44-2.17 2.294-3.26 5.01-3.26 8.15v53.978c0 3.385 1.082 6.158 3.26 8.336 2.18 2.18 4.946 3.257 8.336 3.257h81.158V359.4H34.786c-3.384 0-6.157 1.09-8.335 3.27-2.17 2.167-3.26 4.952-3.26 8.323v46.377c0 3.385 1.082 6.158 3.26 8.336 2.18 2.18 4.95 3.257 8.336 3.257zM199.628 77.18h115.938c25.6 0 46.248 7.484 61.953 22.46 15.696 14.975 23.548 34.546 23.548 58.69 0 24.156-7.852 43.733-23.55 58.69-15.704 14.99-36.353 22.474-61.952 22.474H199.628V77.18z"
                          />
                        </svg>
                      </span>
                    </div>
                    <span>
                      {{ link.name }}
                    </span>
                    <button>
                      {{ popupSettings.skuLinkText || popupText.buy }}
                    </button>
                  </a>
                </div>
              </div>
            </div>

            <div
              class="frisbuy-comments"
              v-if="
                post.instagramPost.commentList &&
                post.instagramPost.commentList.length
              "
            >
              <div v-for="commment in post.instagramPost.commentList">
                <strong>{{ commment.author.username }}</strong>
                <span v-html="tageted(commment.text)"></span>
              </div>
              <a>{{ popupText.loadMoreComments }}</a>
            </div>
          </div>
        </div>
      </div>

      <div v-if="false" class="frisbuy-status-line">
        <span></span>
        <div class="frisbuy-status-warning" v-if="false">
          <svg viewBox="0 0 25 23">
            <ellipse
              cx="12.1644725"
              cy="18.1519016"
              rx="0.855296703"
              ry="0.850622951"
            ></ellipse>
            <path
              d="M11.403956,8.67665574 L11.403956,15.202623 C11.403956,15.6200164 11.7440275,15.9586066 12.1644725,15.9586066 C12.5849176,15.9586066 12.924989,15.6203934 12.924989,15.202623 L12.924989,8.67665574 C12.924989,8.2592623 12.5849176,7.92029508 12.1644725,7.92029508 C11.7440275,7.92029508 11.403956,8.25888525 11.403956,8.67665574 Z"
              id="Shape"
            ></path>
            <path
              d="M24.175022,21.5800328 L12.8355165,0.407967213 C12.5712692,-0.0852131148 11.7572967,-0.0852131148 11.4934286,0.407967213 L0.154302198,21.5800328 C0.0288131868,21.8145574 0.0360164835,22.0973443 0.173637363,22.3247049 C0.310879121,22.5528197 0.558445055,22.6923279 0.825725275,22.6923279 L23.5032198,22.6923279 C23.7705,22.6923279 24.0176868,22.5531967 24.1556868,22.3247049 C24.2925495,22.0973443 24.3001319,21.8145574 24.175022,21.5800328 Z M2.09236813,21.1796066 L12.1644725,2.37201639 L22.236956,21.1796066 L2.09236813,21.1796066 Z"
            ></path>
          </svg>
        </div>
        <div
          class="frisbuy-social-buttons"
          v-if="popupSettings.shareButtons.enable"
        >
          <a
            class="frisbuy-social-button"
            v-if="
              popupSettings.shareButtons.vk.isEnabled &&
              !settings.isOwnerShopifyUser
            "
            target="_blank"
            @click="shareClick('vk')"
            :href="
              popupSettings.shareButtons.vk.customLink ||
              `https://vk.com/share.php?url=${shareUrl(
                'vk'
              )}&title=${encodedDescription}&image=${
                currentMedia.imageHighResolutionUrl
              }&noparse=true`
            "
          >
            <svg viewBox="0 0 20 12">
              <g transform="translate(-774.000000, -789.000000)">
                <g transform="translate(388.000000, 47.000000)">
                  <path
                    fill="currentColor"
                    d="M405.87071,752.826675 C405.846521,752.771987 405.823971,752.726624 405.803024,752.69028 C405.45643,752.035439 404.794098,751.231669 403.81643,750.278739 L403.795774,750.256917 L403.785428,750.246217 L403.774973,750.235248 L403.764481,750.235248 C403.320765,749.791516 403.039781,749.493159 402.922113,749.340408 C402.706812,749.049427 402.658579,748.754892 402.776248,748.456459 C402.859381,748.230981 403.171658,747.754803 403.71235,747.027274 C403.996758,746.641707 404.222004,746.332688 404.388342,746.099873 C405.588015,744.426752 406.108124,743.357605 405.948561,742.892013 L405.886594,742.78321 C405.844954,742.717707 405.737486,742.657783 405.564335,742.603134 C405.390783,742.548599 405.168962,742.53958 404.89847,742.575924 L401.90306,742.597631 C401.854536,742.579592 401.785246,742.581274 401.694973,742.603134 C401.604809,742.624994 401.559709,742.635962 401.559709,742.635962 L401.507577,742.663287 L401.466193,742.696115 C401.431512,742.717822 401.39337,742.756 401.35173,742.810573 C401.31031,742.864955 401.275665,742.928777 401.247978,743.001503 C400.921858,743.881669 400.551075,744.7 400.134936,745.456459 C399.878361,745.907529 399.642732,746.298446 399.427541,746.629439 C399.212641,746.960318 399.03235,747.204102 398.886849,747.360369 C398.741129,747.51679 398.609617,747.642102 398.491512,747.736764 C398.373588,747.831465 398.28357,747.871478 398.221239,747.856841 C398.158761,747.842204 398.099927,747.827682 398.044226,747.813159 C397.947213,747.747656 397.86918,747.658573 397.810346,747.545834 C397.751257,747.433096 397.711475,747.291197 397.690674,747.120255 C397.669982,746.949197 397.657741,746.802064 397.654244,746.678357 C397.651002,746.554803 397.652495,746.380038 397.659526,746.154561 C397.66674,745.928968 397.669982,745.776331 397.669982,745.696306 C397.669982,745.419847 397.675118,745.119809 397.685428,744.796115 C397.69592,744.47242 397.704408,744.215949 397.711512,744.027006 C397.718579,743.837873 397.721858,743.637771 397.721858,743.426815 C397.721858,743.21586 397.709617,743.05042 397.685428,742.930344 C397.66153,742.81042 397.624845,742.694013 397.576503,742.581159 C397.527869,742.46842 397.456685,742.38121 397.363279,742.319299 C397.26969,742.257465 397.153333,742.208395 397.014863,742.171936 C396.647322,742.084688 396.179308,742.03749 395.610601,742.030153 C394.320947,742.015631 393.492277,742.102994 393.124772,742.292127 C392.979162,742.372038 392.847395,742.481223 392.729581,742.619338 C392.604736,742.779427 392.587322,742.86679 392.67745,742.881159 C393.093552,742.946548 393.388124,743.102968 393.561494,743.350268 L393.623971,743.481312 C393.672568,743.57586 393.721093,743.743248 393.769654,743.983248 C393.818142,744.223248 393.849435,744.488739 393.863206,744.779567 C393.897814,745.310662 393.897814,745.765287 393.863206,746.143478 C393.828488,746.521822 393.795701,746.816357 393.764408,747.027312 C393.733115,747.238268 393.686339,747.40921 393.623971,747.540102 C393.561494,747.671032 393.519927,747.751057 393.499089,747.780102 C393.478288,747.809146 393.460947,747.827452 393.447177,747.834637 C393.357049,747.870866 393.263315,747.889325 393.166302,747.889325 C393.069144,747.889325 392.95133,747.838344 392.812678,747.736459 C392.674062,747.634573 392.5302,747.494624 392.381093,747.316382 C392.231985,747.138102 392.063825,746.888968 391.876539,746.568943 C391.689399,746.248917 391.495228,745.870688 391.294135,745.434255 L391.12776,745.117745 C391.023752,744.914127 390.881676,744.617643 390.701384,744.228561 C390.520984,743.839325 390.36153,743.462815 390.222914,743.099108 C390.167505,742.946357 390.084262,742.830064 389.973333,742.750038 L389.921275,742.71721 C389.886667,742.688166 389.831111,742.657325 389.7549,742.624459 C389.678579,742.591631 389.598944,742.568089 389.515665,742.553605 L386.665792,742.575312 C386.374572,742.575312 386.176976,742.644522 386.072933,742.782752 L386.031293,742.84814 C386.010492,742.884561 386,742.942726 386,743.02279 C386,743.102815 386.020801,743.201032 386.062441,743.317325 C386.47847,744.343057 386.930893,745.332293 387.419709,746.285185 C387.908525,747.238076 388.333297,748.005656 388.69377,748.587236 C389.054317,749.169236 389.421821,749.718522 389.796284,750.234828 C390.170747,750.751325 390.418616,751.082318 390.539891,751.227732 C390.661311,751.373414 390.756685,751.482331 390.826011,751.555057 L391.086084,751.816879 C391.252495,751.99149 391.496867,752.200611 391.819308,752.444242 C392.141821,752.688025 392.498871,752.928025 392.890638,753.164624 C393.282477,753.400841 393.738324,753.593605 394.258434,753.742688 C394.77847,753.891924 395.284627,753.951809 395.776976,753.922917 L396.973115,753.922917 C397.215701,753.900943 397.39949,753.820917 397.524408,753.682803 L397.565792,753.628115 C397.593625,753.584701 397.619672,753.517248 397.643716,753.426484 C397.668051,753.335567 397.680146,753.235401 397.680146,753.126446 C397.673042,752.81372 397.695738,752.531873 397.747614,752.280943 C397.799454,752.030089 397.858543,751.840955 397.924627,751.71358 C397.990674,751.586318 398.065209,751.47893 398.14816,751.391873 C398.231293,751.304624 398.290528,751.251771 398.325282,751.23358 C398.359818,751.215274 398.387395,751.202854 398.408197,751.195401 C398.574608,751.137236 398.770455,751.193567 398.996029,751.364662 C399.221421,751.535605 399.432823,751.746675 399.630565,751.997529 C399.828197,752.248611 400.065647,752.530306 400.342951,752.843032 C400.620437,753.155873 400.86306,753.38842 401.071002,753.541401 L401.278944,753.672331 C401.417814,753.759694 401.598106,753.83972 401.820036,753.912446 C402.041566,753.985134 402.235665,754.003325 402.402332,753.966981 L405.064882,753.923414 C405.328233,753.923414 405.533151,753.877669 405.678506,753.786904 C405.824153,753.695987 405.910674,753.595822 405.938579,753.486866 C405.966412,753.377796 405.967905,753.254051 405.943862,753.115707 C405.919199,752.977707 405.8949,752.88121 405.87071,752.826675 Z"
                  ></path>
                </g>
              </g>
            </svg>
          </a>
          <a class="frisbuy-social-button" v-if="false">
            <svg viewBox="0 0 12 20">
              <g transform="translate(-814.000000, -784.000000)">
                <g transform="translate(774.000000, 784.000000)">
                  <path
                    fill="currentColor"
                    d="M46.2638186,16.8871094 C47.4239466,16.8871094 48.3674174,15.933548 48.3674174,14.7610122 C48.3674174,13.5896069 47.4239466,12.6358194 46.2638186,12.6358194 C45.1048092,12.6358194 44.1602198,13.5896069 44.1602198,14.7610122 C44.1602198,15.933548 45.1048092,16.8871094 46.2638186,16.8871094 Z M46.2638186,9.62760725 C49.0662681,9.62760725 51.3443559,11.9300596 51.3443559,14.7610122 C51.3443559,17.5930953 49.0662681,19.8964521 46.2638186,19.8964521 C43.4620402,19.8964521 41.1832813,17.5930953 41.1832813,14.7610122 C41.1832813,11.9301727 43.4620402,9.62760725 46.2638186,9.62760725 Z M48.3193211,5.43860681 C49.3536157,5.67679933 50.351111,6.09032959 51.2696389,6.67365821 C51.9647985,7.11646795 52.1744089,8.04538488 51.736285,8.74809239 C51.2987203,9.45238257 50.3801925,9.66412182 49.6838025,9.22131208 C47.6027978,7.89830919 44.9232735,7.89887443 42.8433873,9.22131208 C42.1468855,9.66412182 41.2284695,9.45226952 40.7913522,8.74809239 C40.3532283,8.04481963 40.5621677,7.11646795 41.257551,6.67365821 C42.175967,6.09100788 43.1734623,5.67679933 44.2077569,5.43860681 L41.3672777,2.56786123 C40.7865426,1.98034982 40.7865426,1.02803192 41.367837,0.440633558 C41.6587638,0.147160473 42.0393958,8.47861378e-05 42.419916,8.47861378e-05 C42.8011073,8.47861378e-05 43.1822986,0.147047425 43.4732254,0.440633558 L46.2631475,3.26163793 L49.0555304,0.440633558 C49.6362655,-0.146877853 50.5785059,-0.146877853 51.1596884,0.440633558 C51.741542,1.02803192 51.741542,1.98102811 51.1596884,2.56786123 C51.1598003,2.56786123 48.3193211,5.43860681 48.3193211,5.43860681 Z"
                    id="Shape"
                    transform="translate(46.263727, 9.948226) scale(1, -1) translate(-46.263727, -9.948226) "
                  ></path>
                </g>
              </g>
            </svg>
          </a>
          <a
            class="frisbuy-social-button"
            v-if="
              popupSettings.shareButtons.facebook &&
              !settings.gallery.censorship.hide_fb
            "
            @click="shareClick('facebook')"
            target="_blank"
            :href="`https://www.facebook.com/sharer/sharer.php?kid_directed_site=0&sdk=joey&u=${currentLocation}`"
          >
            <svg viewBox="0 0 12 20">
              <g transform="translate(-844.000000, -784.000000)">
                <g transform="translate(388.000000, 47.000000)">
                  <path
                    fill="currentColor"
                    d="M467.129702,737.004124 L464.573304,737 C461.701277,737 459.845248,738.914433 459.845248,741.877526 L459.845248,744.126392 L457.274903,744.126392 C457.052795,744.126392 456.872934,744.307423 456.872934,744.530722 L456.872934,747.789072 C456.872934,748.012371 457.053,748.193196 457.274903,748.193196 L459.845248,748.193196 L459.845248,756.415052 C459.845248,756.638351 460.025108,756.819175 460.247217,756.819175 L463.600785,756.819175 C463.822893,756.819175 464.002754,756.638144 464.002754,756.415052 L464.002754,748.193196 L467.008086,748.193196 C467.230195,748.193196 467.410055,748.012371 467.410055,747.789072 L467.411286,744.530722 C467.411286,744.423505 467.368833,744.320825 467.293566,744.244948 C467.2183,744.169072 467.115756,744.126392 467.009112,744.126392 L464.002754,744.126392 L464.002754,742.22 C464.002754,741.303711 464.21994,740.838557 465.407184,740.838557 L467.129292,740.837938 C467.351195,740.837938 467.531056,740.656907 467.531056,740.433814 L467.531056,737.408247 C467.531056,737.185361 467.3514,737.004536 467.129702,737.004124 Z"
                    id="Shape"
                  ></path>
                </g>
              </g>
            </svg>
          </a>
          <a
            class="frisbuy-social-button"
            v-if="
              popupSettings.shareButtons.twitter &&
              !settings.isOwnerShopifyUser &&
              !settings.gallery.censorship.hide_twitter
            "
            target="_blank"
            @click="shareClick('twitter')"
            :href="`https://twitter.com/intent/tweet?text=${twitterText}&url=${shareUrl(
              'twitter'
            )}`"
          >
            <svg viewBox="0 0 20 17">
              <g transform="translate(-874, -786)">
                <g transform="translate(388, 47)">
                  <path
                    fill="currentColor"
                    d="M505.985975,740.917082 C505.25038,741.239982 504.461097,741.458969 503.63181,741.556735 C504.478569,741.054414 505.126741,740.257662 505.433944,739.311189 C504.639665,739.77637 503.762927,740.114151 502.828746,740.297261 C502.080676,739.506688 501.016619,739.014267 499.836401,739.014267 C497.572173,739.014267 495.736305,740.832968 495.736305,743.074794 C495.736305,743.392744 495.772521,743.703286 495.842472,744.00024 C492.435517,743.830718 489.414467,742.213696 487.39252,739.756571 C487.039075,740.355396 486.838007,741.053152 486.838007,741.79798 C486.838007,743.207176 487.562368,744.450572 488.6614,745.178026 C487.989486,745.155769 487.357544,744.972659 486.804305,744.668297 L486.804305,744.719024 C486.804305,746.686186 488.218051,748.327957 490.092618,748.701617 C489.749166,748.793171 489.387002,748.843898 489.012331,748.843898 C488.747582,748.843898 488.491552,748.81792 488.240519,748.768422 C488.762539,750.382986 490.276215,751.557085 492.069629,751.589274 C490.667117,752.67803 488.898685,753.325091 486.977909,753.325091 C486.646964,753.325091 486.320984,753.305292 486.000033,753.269414 C487.814674,754.423746 489.969012,755.096786 492.284446,755.096786 C499.826474,755.096786 503.949071,748.908245 503.949071,743.541237 L503.935322,743.015429 C504.740835,742.44627 505.437699,741.731174 505.985975,740.917082 Z"
                    id="Shape"
                  ></path>
                </g>
              </g>
            </svg>
          </a>
          <a
            class="frisbuy-social-button"
            v-if="shareLinkSupport"
            @click="shareLink"
          >
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48.665 48.665">
              <path
                fill="currentColor"
                d="M40.332 31.592c-2.377 0-4.515 1-6.033 2.598L16.56 25.504c.06-.406.103-.82.103-1.246 0-.414-.04-.818-.098-1.215l17.71-8.59a8.3 8.3 0 0 0 6.055 2.62 8.333 8.333 0 0 0 8.333-8.333c0-4.603-3.73-8.333-8.333-8.333S32 4.137 32 8.74c0 .414.04.817.097 1.215l-17.71 8.59a8.3 8.3 0 0 0-6.053-2.62A8.333 8.333 0 0 0 0 24.258a8.332 8.332 0 0 0 8.333 8.333 8.3 8.3 0 0 0 6.033-2.595l17.736 8.685c-.062.406-.104.82-.104 1.245 0 4.604 3.73 8.333 8.333 8.333s8.334-3.73 8.334-8.333a8.33 8.33 0 0 0-8.332-8.333z"
              />
            </svg>
          </a>
          <a
            :class="{
              'frisbuy-social-button': true,
              'frisbuy-tooltip': linkCopied,
            }"
            v-else
            @click="copyLinkToClipboard"
          >
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 457.03 457.03">
              <path
                fill="currentColor"
                d="M421.512 207.074l-85.795 85.767c-47.352 47.38-124.17 47.38-171.53 0-7.46-7.438-13.295-15.82-18.42-24.464l39.864-39.86c1.896-1.912 4.236-3.007 6.472-4.297 2.756 9.415 7.567 18.33 14.972 25.735 23.648 23.667 62.128 23.634 85.762 0l85.768-85.765c23.666-23.664 23.666-62.135 0-85.78-23.635-23.647-62.105-23.647-85.768 0l-30.5 30.53c-24.75-9.636-51.414-12.227-77.372-8.423l64.99-64.99c47.38-47.37 124.178-47.37 171.558 0 47.357 47.37 47.357 124.18 0 171.547zm-226.804 141.03l-30.52 30.532c-23.647 23.634-62.13 23.634-85.78 0-23.647-23.667-23.647-62.138 0-85.795l85.78-85.766c23.664-23.662 62.12-23.662 85.766 0 7.388 7.39 12.204 16.302 14.986 25.706 2.25-1.307 4.56-2.37 6.454-4.266l39.86-39.845c-5.09-8.68-10.957-17.03-18.42-24.478-47.348-47.37-124.172-47.37-171.543 0L35.527 249.96c-47.366 47.385-47.366 124.172 0 171.553 47.37 47.356 124.177 47.356 171.547 0l65.008-65.003c-25.97 3.826-52.643 1.213-77.372-8.406z"
              />
            </svg>
          </a>
        </div>
        <span>
          <div v-if="popupSettings.popupBranding" class="frisbuy-popup-brand">
            <a
              v-if="settings.locale == 'en'"
              :href="
                settings.brandingLink ||
                'https://www.frisbuy.com/?utm_source=gallery&utm_medium=referral&utm_campaign=' +
                  settings.customerCode
              "
              target="_blank"
            >
              <img
                :src="`${envDomain}/images/widget/frisbuy_gray.svg`"
                alt="frisbuy"
              />
            </a>
            <a
              v-else
              :href="
                settings.brandingLink ||
                'https://www.frisbuy.ru/?utm_source=gallery&utm_medium=referral&utm_campaign=' +
                  settings.customerCode
              "
              target="_blank"
            >
              <img
                :src="`${envDomain}/images/widget/frisbuy_gray.svg`"
                alt="frisbuy"
              />
            </a>
          </div>
        </span>
      </div>
    </div>
  </div>
</template>

<style scoped lang="scss">
$lassiePrimaryColor: #002354;
$arrowButtonsWidth: 46px;

.frisbuy-popup-overlay {
  background-color: #{$lassiePrimaryColor}7d; // opacity 50%

  min-height: 100dvh;

  .frisbuy-popup {
    position: relative;
    padding: 0;

    max-width: 1184px;
    max-height: 676px;

    .frisbuy-popup-controls {
      display: flex;
      position: absolute;

      inset: 0;
      flex-direction: column;
      justify-content: center;

      width: calc(100% + ($arrowButtonsWidth * 2) + (16px * 2));
      transform: translateX(calc(-1 * ($arrowButtonsWidth + 16px)));

      pointer-events: none;

      z-index: 1;

      .frisbuy-popup-navigation {
        display: flex;
        justify-content: space-between;
      }

      .frisbuy-popup-control {
        &.frisbuy-prev,
        &.frisbuy-next,
        &.frisbuy-close {
          pointer-events: all;

          width: $arrowButtonsWidth;
          height: 48px;

          border: 1px solid $lassiePrimaryColor;
          background: #ffffff;

          svg {
            &,
            path {
              fill: $lassiePrimaryColor;
              stroke: $lassiePrimaryColor;
              stroke-width: 1.5;
            }
          }

          &:hover {
            border: 1px solid $lassiePrimaryColor;
            background: #ffffff;

            svg {
              &,
              path {
                fill: #667b98;
                stroke: #667b98;
              }
            }
          }
        }

        &.frisbuy-prev,
        &.frisbuy-next {
          position: relative;

          svg {
            width: 16px;
            height: 12px;
          }
        }

        &.frisbuy-close {
          transform: translateY(-50%);

          svg {
            width: 18px;
            height: 18px;
          }
        }
      }
    }

    .frisbuy-content-wrapper {
      padding: 32px;

      .frisbuy-popup-content {
        .frisbuy-popup-media {
          display: flex;
          flex-direction: column;

          width: 100%;
          max-width: 600px;
          aspect-ratio: 1 / 1;

          overflow: visible;

          .frisbuy-gallery-navigation {
            width: calc(100% + 48px); // 48px - width .frisbuy-navigation-button
            left: calc(-48px / 2);

            .frisbuy-navigation-button {
              width: 48px;
              height: 48px;

              transform: none;
              opacity: 1;
              box-shadow: 0px 0px 40px 0px #00235417;

              margin: 0;

              &:last-child {
                transform: scale(-1, 1);
              }

              svg {
                width: 22px;
                height: 16px;

                &,
                path {
                  fill: $lassiePrimaryColor;
                  stroke: $lassiePrimaryColor;
                  stroke-width: 1.5;
                }
              }

              &:hover {
                svg {
                  &,
                  path {
                    fill: #667b98;
                    stroke: #667b98;
                  }
                }
              }
            }
          }

          .frisbuy-gallery-pagination {
            position: relative;
            bottom: 0;

            height: fit-content;

            margin-top: 12px;

            .frisbuy-gallery-page {
              width: 100%;
              max-width: 40px;
              height: 2px;

              box-shadow: none;
              border-radius: none;

              background-color: #b8c2cf47;

              margin: 0;

              &:not(:first-child) {
                margin: 0 0 0 14px;
              }

              &.active {
                background-color: $lassiePrimaryColor;
              }
            }
          }
        }
      }

      .frisbuy-popup-details {
        height: calc(
          100% + 32px
        ); // 32px - bottom padding (.frisbuy-content-wrapper)

        // padding-left: 32px;
        padding-left: 20px; // +12px from .frisbuy-details-scroller

        .frisbuy-details-scroller {
          padding-right: 0;
          padding-left: 12px; // 12 px for .frisbuy-popup-details. It's need for .frisbuy-marker overflow

          .frisbuy-post-details {
            &,
            * {
              color: $lassiePrimaryColor;
              font-size: 16px;
            }

            svg {
              width: 100%;
              height: 100%;
            }

            a {
              margin: 0;
            }
          }

          .frisbuy-post-text {
            margin: 14px 0 0 0;
          }

          .frisbuy-products-list__title {
            margin-top: 24px;
            color: $lassiePrimaryColor;
            font-size: 16px;
            text-transform: uppercase;
          }

          .frisbuy-products-list {
            padding: 22px 0;
            margin: 12px 0 0;

            .frisbuy-product-item {
              display: flex;
              flex-direction: row;
              width: 100%;
              height: 160px;

              border-top: 1px solid #dee2e9;

              padding-top: 20px;
              margin: 0;

              &:not(:first-child) {
                margin: 20px 0 0 0;
              }

              .frisbuy-marker {
                border-color: $lassiePrimaryColor;
                color: $lassiePrimaryColor;

                width: 24px;
                height: 24px;

                inset: 0;
                // translate 50% from width and 50% from parrent's padding
                transform: translate(-12px, 10px);
                
                &.frisbuy-marker-hover {
                  background-color: $lassiePrimaryColor;
                  color: #ffffff;
                }
              }

              .frisbuy-product-image {
                display: inline-block;
                width: 130px;
                height: 100%;
                background-size: cover;
                margin: 0;

                .frisbuy-similar-title {
                  position: absolute;
                  inset: auto 0 6px 50%;
                  transform: translateX(-50%);

                  width: fit-content;
                  white-space: nowrap;

                  background-color: #f9fafb;
                  color: #5c6f83;

                  font-size: 14px;
                  font-weight: 400;

                  border-radius: 0;

                  text-transform: none;
                  text-align: center;

                  margin: 0 auto;
                  padding: 4px 8px;
                }
              }

              .frisbuy-product-item__info {
                display: flex;
                flex-direction: column;
                justify-content: space-between;

                flex-grow: 1;

                margin-left: 20px;

                * {
                  text-align: left;
                }

                .frisbuy-product-item__title {
                  color: $lassiePrimaryColor;
                  text-transform: uppercase;
                  font-size: 16px;

                  height: 69px;
                }

                .frisbuy-product-price {
                  display: inline-block;
                  vertical-align: middle;

                  color: $lassiePrimaryColor;
                  height: 20px;
                  font-family: inherit;
                  font-size: 18px;
                  font-weight: 400;

                  margin-top: 10px;

                  .frisbuy-price-old {
                    color: #5c6f83;
                    font-size: 0.7777778em;
                  }
                }

                .frisbuy-product-item__buy-button {
                  font-family: inherit;
                  color: #ffffff;
                  background-color: $lassiePrimaryColor;
                  border: 1px solid $lassiePrimaryColor;

                  width: fit-content;
                  height: fit-content;

                  text-transform: capitalize;

                  padding: 10px 32px;
                  margin-top: 16px;

                  &:hover {
                    color: $lassiePrimaryColor;
                    background-color: #ffffff;
                  }
                }
              }
            }
          }
        }

        &:after {
          display: none;
        }
      }
    }
  }
}

// media queries
// @media only screen and (max-width: 1199px) {
@media only screen and (max-width: 1300px) {
  .frisbuy-popup-overlay {
    .frisbuy-popup {
      max-width: 951px;
      max-height: 543px;
    }
  }
}

// @media only screen and (max-width: 991px) {
@media only screen and (max-width: 1199px) {
  .frisbuy-popup-overlay {
    .frisbuy-popup {
      max-width: 850px;
      max-height: 485px;

      .frisbuy-popup-controls {
        align-items: unset;
        margin: unset;

        .frisbuy-popup-control {
          &.frisbuy-close {
            position: absolute;
          }
        }
      }

      .frisbuy-content-wrapper {
        height: 100%;
      }
    }
  }
}

@media only screen and (max-width: 991px) {
  .frisbuy-popup-overlay {
    .frisbuy-popup {
      max-width: 650px;
      max-height: 371px;
    }
  }
}

@media only screen and (max-width: 767px) {
  .frisbuy-popup-overlay {
    .frisbuy-popup {
      max-width: 470px;
      max-height: 100%;

      .frisbuy-content-wrapper {
        padding: 8px 16px 0;

        height: calc(100% - 48px);

        .frisbuy-popup-content {
          .frisbuy-popup-media {
            .frisbuy-gallery-navigation {
              .frisbuy-navigation-button {
                display: none;
              }
            }
          }
        }

        .frisbuy-popup-details {
          padding-left: 0;
          margin-top: 24px;

          .frisbuy-details-scroller {
            padding-left: 0;

            .frisbuy-post-text {
              margin: 8px 0 0 0;
            }

            .frisbuy-product-image {
              .frisbuy-similar-title {
                font-size: 10px;

                margin: 0 4px;
              }
            }

            .frisbuy-products-list {
              .frisbuy-product-item {
                .frisbuy-marker {
                  transform: translateY(20px);
                }
              }
            }
          }
        }
      }

      .frisbuy-popup-controls {
        display: flex;
        position: static;
        flex-direction: row;
        justify-content: space-between;
        width: 100%;
        transform: none;
        pointer-events: none;

        padding: 4px 0;

        .frisbuy-popup-navigation {
          justify-content: start;
        }

        .frisbuy-popup-control {
          &.frisbuy-prev,
          &.frisbuy-next,
          &.frisbuy-close {
            border: none;
            background: transparent;

            &:hover {
              border: none;
              background: transparent;
            }
          }

          &.frisbuy-prev,
          &.frisbuy-next {
            svg {
              width: 22px;
              height: 16px;
            }
          }

          &.frisbuy-prev {
            transform: none;
          }

          &.frisbuy-next {
            transform: scale(-1, 1);
          }

          &.frisbuy-close {
            position: relative;
            transform: none;
          }
        }
      }
    }
  }
}
</style>

<script>
import defaultPopup from "@/gallery/popup/popup.vue";
import popupImage from "./popupimage/popupimage.vue";

export default {
  extends: defaultPopup,

  components: {
    "post-image": popupImage,
  },

  methods: {
    swipeHandler(direction) {
      if (!this.isMobile) return;

      let selectedMediaIndex = this.mediaIndex;

      switch (direction) {
        case "left":
          selectedMediaIndex = this.mediaIndex + 1;
          break;
        case "right":
          selectedMediaIndex = this.mediaIndex - 1;
          break;
      }

      if (selectedMediaIndex >= this.post.media.length) {
        this.popupNext();
      } else if (selectedMediaIndex < 0) {
        this.popupPrev();
      } else {
        this.navigate(selectedMediaIndex);
      }

      this.swipeStyle = null;
    },
  },
};
</script>
